import React from 'react';
import {
	ChecklistItem,
	ProfileSection,
	ProfileSectionTitle,
} from '../Global/profileStyles';
import { IonLabel, IonToggle, ToggleChangeEventDetail } from '@ionic/react';
import { useAppDispatch, useAppSelector } from '../../state/hooks';
import { ITaxonomy } from '../../models/interfaces/ITaxonomy';
import { IonToggleCustomEvent } from '@ionic/core';
import { UPDATE_PREFS_ACTIVITIES } from '../../state/prefsSlice';
import { selectPrefs } from '../../state/selectors';
import _ from 'lodash';

type ActivitiesListProps = {
	activities: ITaxonomy[];
};

type TaxToggleProps = {
	activity: ITaxonomy;
	isChecked: boolean;
	clickCallback: (
		e: IonToggleCustomEvent<ToggleChangeEventDetail<any>>,
		activity: ITaxonomy,
	) => {};
};

const ActivityToggle = ({ activity, clickCallback, isChecked }: TaxToggleProps) => {
	return (
		<>
			<IonLabel>{_.unescape(activity.title)}</IonLabel>
			<IonToggle
				onIonChange={(e) => clickCallback(e, activity)}
				checked={isChecked}
			/>
		</>
	);
};

const ActivitiesList: React.FC<ActivitiesListProps> = ({ activities }) => {
	const dispatch = useAppDispatch();
	const activityPrefs = useAppSelector(
		selectPrefs,
		_.isEqual,
	);
	const selectedActivities = activityPrefs.activities ?? [];
	const sortedActivities = [...activities].sort((a, b) =>
		_.unescape(a.title).localeCompare(_.unescape(b.title)),
	);

	const clickHandler = (
		e: IonToggleCustomEvent<ToggleChangeEventDetail<any>>,
		activity: ITaxonomy,
	) => {
		e.stopImmediatePropagation();
		let newActivityPrefs: ITaxonomy[];

		switch (e.detail.checked) {
			case true:
				console.log('Add');
				console.log('Src : ', selectedActivities);
				// Item Checked, add it to activity prefs array
				newActivityPrefs = [...selectedActivities];
				newActivityPrefs.push(activity);
				console.log('Dst : ', newActivityPrefs);

				dispatch({
					type: UPDATE_PREFS_ACTIVITIES,
					payload: {
						activities: newActivityPrefs,
					},
				});
				break;
			default:
				// Item Unchecked, remove it from activity prefs array
				console.log('Del');
				console.log('Src : ', selectedActivities);
				newActivityPrefs = _.filter(selectedActivities, (currentObject) => {
					return currentObject.slug !== activity.slug;
				});
				console.log('Dst : ', newActivityPrefs);

				dispatch({
					type: UPDATE_PREFS_ACTIVITIES,
					payload: {
						activities: newActivityPrefs,
					},
				});
		}

		return {};
	};

	return (
		<ProfileSection>
			<ProfileSectionTitle>Activities</ProfileSectionTitle>
			<p className="description">Select preferred activities...</p>
			{sortedActivities.map((activity) => {
				return (
					<ChecklistItem key={activity.id}>
						<ActivityToggle
							activity={activity}
							isChecked={!!_.find(selectedActivities, {
								slug: activity.slug,
							})}
							clickCallback={clickHandler}
						/>
					</ChecklistItem>
				);
			})}
		</ProfileSection>
	);
};

export default ActivitiesList;
